<template>
  <div class="duty-user">
    <!-- <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList(1)">
      <el-form-item label="任务状态">
        <el-select v-model="dataForm.status" placeholder="请选择">
          <el-option label="未处理" value="N"></el-option>
          <el-option label="已完成" value="Y"></el-option>
          <el-option label="进行中" value="I"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getDataList(1)">查询</el-button>
        <el-button @click="cleaList()">重置</el-button>
      </el-form-item>
    </el-form> -->

    <el-button type="primary" class="addBtn" @click="addOrUpdateHandle()"
      >新增</el-button
    >

    <el-table :data="dataList" border v-loading="dataListLoading" style="width: 100%;">
      <el-table-column prop="bannerName" align="center" min-width="150" label="banner名称"></el-table-column>
      <el-table-column prop="bannerImg" align="center" min-width="180" label="banner图片">
        <template slot-scope="scope">
          <el-image style="width: 100px; height: 50px" :src="scope.row.bannerImg"></el-image>
        </template>
      </el-table-column>
      <el-table-column align="center" min-width="150" label="操作">
        <template slot-scope="scope">
          <!-- <el-button type="text" size="small" @click="addOrUpdateHandle(scope.row.taskId)">查看</el-button> -->
          <el-button type="text" size="small" @click="deleteHandle(scope.row.bannerId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
      :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      :total="totalPage"
      layout="total, sizes, prev, pager, next, jumper"
    ></el-pagination>
    <!-- 弹窗, 新增 / 修改 -->
    <banner-edit v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></banner-edit>
  </div>
</template>

<script>
import bannerEdit from "./comm/bannerEdit";
import {bannerListData, bannerDelete} from './api'
export default {
  components: {
    bannerEdit,
  },
  data() {
    return {
      dataForm: {
        status: 'N',
        taskUser: ''
      },
      dataList: [{}],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      addOrUpdateVisible: false,
      type: ''
    };
  },
  mounted() {
    this.getDataList();
    // 判断组长和公司管理
    if(sessionStorage.getItem('isChairman')  == 'Y'){
      this.type = true;
    }else if(sessionStorage.getItem('isLeader')  == 'Y') {
      this.type = false;
    };
  },
  methods: {
    // 获取任务列表
    getDataList(page) {
      this.dataListLoading = true;
      bannerListData({
          page: page || this.pageIndex,
          limit: this.pageSize,
          isLeader: 'Y'
        }).then(data => {
          if (data && data.code === 0) {
            this.dataList = data.page?data.page.list:[];
            this.totalPage = data.page?data.page.totalCount:0;
            this.pageSize = data.page?data.page.pageSize:10;
          } else {
            this.dataList = [];
            this.totalPage = 0;
            this.$message.error(data.msg);
          }
          this.dataListLoading = false;
        });
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },
    // 新增 / 修改
    addOrUpdateHandle(id) {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id);
      });
    },
    // 重置
    cleaList() {
      this.dataForm = {};
      this.pageIndex = 1;
      this.getDataList();
    },
    // 删除
    deleteHandle(id) {
      let bannerId = [id];
      this.$confirm(
        `确定进行删除操作?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
         bannerDelete(bannerId).then(data => {
           
            if (data && data.code === 0) {
              this.$message({
                message: "操作成功",
                type: "success",
                duration: 1500,
                onClose: () => {
                  this.getDataList();
                },
              });
            } else {
              this.$message.error(data.msg);
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.addBtn {
  margin-bottom: 20px;
}
</style>